"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Group = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var clsx_1 = tslib_1.__importDefault(require("clsx"));
var react_select_1 = require("react-select");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/fp/isEmpty"));
var some_1 = tslib_1.__importDefault(require("lodash/fp/some"));
var getSelections = function (props) {
    var children = react_1.default.Children.toArray(props.children);
    return {
        indeterminate: children.some(function (opt) { var _a; return (_a = opt === null || opt === void 0 ? void 0 : opt.props) === null || _a === void 0 ? void 0 : _a.isSelected; }),
        allSelected: children.every(function (opt) { var _a; return (_a = opt === null || opt === void 0 ? void 0 : opt.props) === null || _a === void 0 ? void 0 : _a.isSelected; }),
    };
};
var hasChildMatchingInputValue = function (_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, _c = _a.inputValue, inputValue = _c === void 0 ? '' : _c;
    if (!inputValue || isEmpty_1.default(options)) {
        return false;
    }
    var regex = new RegExp(inputValue, 'i');
    return some_1.default(function (_a) {
        var label = _a.label;
        return regex.test(label);
    }, options);
};
exports.Group = function (props) {
    var _a = react_1.useState(false), isExpanded = _a[0], setIsExpanded = _a[1];
    var selectProps = props.selectProps, label = props.label, data = props.data;
    var _b = data.underlined, underlined = _b === void 0 ? false : _b;
    var expandableGroups = selectProps.expandableGroups, isGrouped = selectProps.isGrouped, inputValue = selectProps.inputValue;
    var isGroup = label !== '';
    react_1.useEffect(function () {
        if (!isGroup) {
            return;
        }
        var hasChildMatch = hasChildMatchingInputValue({
            options: data === null || data === void 0 ? void 0 : data.options,
            inputValue: inputValue,
        });
        setIsExpanded(hasChildMatch);
    }, [inputValue, data.options, isGroup]);
    var groupProps = tslib_1.__assign(tslib_1.__assign({}, props), { headingProps: {
            data: data,
            isSelected: getSelections(props),
            isExpanded: isExpanded,
            setIsExpanded: setIsExpanded,
        } });
    return (react_1.default.createElement(react_select_1.components.Group, tslib_1.__assign({ className: clsx_1.default({
            expandableGroupEnabled: expandableGroups && isGrouped,
            expandableGroupDisabled: expandableGroups && !isGrouped,
            expandable: expandableGroups && isGroup && isGrouped,
            collapsed: expandableGroups && isGroup && isGrouped && !isExpanded,
            underlined: underlined,
        }) }, groupProps)));
};
exports.Group.displayName = 'FOS_ReactSelect_Group';
